<template>
  <div class="page2-7">
    <img
      class="logo"
      src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-color.png"
    />
    <img
      class="main-student"
      src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/band-student1.png"
    />
    <div class="main-title">乐队</div>
    <div class="sub-title">BAND</div>
    <div class="common-video-button" @click="showVideo('band')">
      <div class="border1"></div>
      <div class="border2"></div>
      <div class="border3"></div>
      <div class="content">
        <van-icon name="play" />
        <span class="text">查看视频</span>
      </div>
    </div>
    <div class="group-type">
      <img
        class="note1"
        src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note3.png"
      />
      <div class="item">
        <span class="dot"></span>
        <span class="text"
          >上课形式:<span class="num">一对多，每周1-2节</span></span
        >
      </div>
    </div>
    <div class="main-desc">
      <img
        class="line"
        src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-blue2.png"
      />
      <div class="title">
        <img
          class="img"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-longest.png"
        />
        <span class="text">一个人的可能性会有极限，一队人的可能性会无极限</span>
      </div>
      <div class="desc">
        音乐窝乐队课，为有乐器基础的孩子提供学习音乐的新视野<br />
        学习以<span class="green">节奏、和弦、旋律</span>三个要素，去
        <span class="green">聆听音乐、理解音乐、改编音乐、创作音乐</span>
        。在学习的过程中，提升音乐演奏技能和音乐素美，同时<span class="green">
          培养团队协作、音乐审美等能力
        </span>
      </div>
    </div>
    <div class="course-wrap">
      <div class="tag">
        <img
          class="img"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
        />
        <span class="text">课程优势</span>
      </div>
      <img
        class="note"
        src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note1.png"
      />
      <div class="list">
        <div class="item">
          <div class="title">
            <img
              class="icon"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon8.png"
            />
            <div class="text">更丰富</div>
          </div>
          <div class="desc">
            根据学习阶段选曲涵盖多种风格
          </div>
        </div>
        <div class="item">
          <div class="title">
            <img
              class="icon"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon5.png"
            />
            <div class="text">更智能</div>
          </div>
          <div class="desc">智能化的曲谱<br />1个人也能练习乐队曲目</div>
        </div>
        <div class="item">
          <div class="title">
            <img
              class="icon"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon15.png"
            />
            <div class="text">更多发展机会</div>
          </div>
          <div class="desc">
            充沛的演艺资源助你登上更大的舞台
          </div>
        </div>
      </div>
    </div>
    <div class="result-wrap">
      <div class="tag">
        <img
          class="img"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
        />
        <span class="text">课程收获</span>
      </div>
      <div class="list">
        <div class="item">
          <van-icon name="success" />
          <span class="text">掌握乐团总谱视谱能力</span>
        </div>
        <div class="item">
          <van-icon name="success" />
          <span class="text"
            >学习多种常见音乐风格，用不同的织体改变歌曲律动</span
          >
        </div>
        <div class="item">
          <van-icon name="success" />
          <span class="text">用级数思维解决变调问题</span>
        </div>
        <div class="item">
          <van-icon name="success" />
          <span class="text">传奇乐手的标志性演奏手法，各乐器技能进阶</span>
        </div>
      </div>
      <img
        class="bottom-img1"
        src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/band-student2.png"
      />
      <img
        class="bottom-img2"
        src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/band-student3.png"
      />
      <img
        class="bottom-line-red1"
        src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-red1.png"
      />
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    showVideo(type) {
      this.$emit("click-video", type);
    },
  },
};
</script>
<style scoped lang="scss">
@function perS($w) {
  @return ($w/375) * 100vw;
}
.page2-7 {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100%;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/bg-light.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  .logo {
    width: perS(90);
    height: auto;
    position: absolute;
    top: 8vh;
    right: perS(28);
    z-index: 100;
  }
  .main-student {
    width: perS(267);
    height: auto;
    position: absolute;
    top: 15vh;
    right: perS(-34);
  }
  .main-title {
    position: relative;
    color: #46b13a;
    margin: 14vh 0 0 perS(25);
    font-size: perS(40);
    line-height: perS(40);
    font-weight: 900;
  }
  .sub-title {
    position: relative;
    color: #000;
    margin: 0 0 0 perS(25);
    font-size: perS(20);
    line-height: perS(20);
    font-weight: 900;
  }
  .group-type {
    margin: perS(8) 0 0 perS(25);
    position: relative;
    .note1 {
      width: perS(35);
      height: auto;
      position: absolute;
      top: perS(-120);
      left: perS(110);
      z-index: 100;
      transform: rotate(35deg);
    }
    .item {
      .dot {
        display: inline-block;
        width: perS(5);
        height: perS(5);
        border-radius: 50%;
        background-color: #46b13a;
        margin-right: perS(4);
      }
      .text {
        color: #000;
        font-size: perS(9);
        line-height: perS(23);
        font-weight: 500;
        .num {
          font-size: perS(12);
          font-weight: 700;
        }
      }
    }
  }
  .main-desc {
    position: relative;
    margin: perS(10) perS(25) 0 perS(25);
    .line {
      position: absolute;
      left: perS(-20);
      top: perS(-15);
      width: perS(48);
      height: auto;
    }
    .title {
      position: relative;
      .img {
        width: perS(307);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-3deg);
        position: absolute;
        top: perS(10.5);
        left: perS(10);
      }
    }
    .desc {
      background-color: #fff;
      margin: perS(-5) 0 0 0;
      padding: perS(10) perS(12);
      border-radius: perS(14);
      font-size: perS(8);
      line-height: perS(13);
      font-weight: 500;
      color: #000;
      box-shadow: 0 1px 2px #eee;
      .green {
        color: #46b13a;
        font-weight: 700;
      }
    }
  }
  .course-wrap {
    position: relative;
    margin: perS(18) perS(25) 0 perS(25);
    .tag {
      position: relative;
      margin-bottom: perS(-5);
      .img {
        width: perS(70);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-7deg);
        position: absolute;
        top: perS(6.5);
        left: perS(10);
      }
    }
    .note {
      position: absolute;
      width: perS(23);
      height: auto;
      right: perS(100);
      top: perS(0);
    }
    .list {
      margin-bottom: perS(10);
      display: flex;
      .item {
        margin-right: perS(5);
        &:last-child {
          margin-right: 0;
        }
        .title {
          display: flex;
          align-items: center;
          .icon {
            width: perS(34);
            height: auto;
            margin-right: perS(4);
          }
          .text {
            font-size: perS(13);
            font-weight: 900;
            line-height: perS(11);
            color: #000;
          }
        }
        .desc {
          width: perS(100);
          font-size: perS(7);
          font-weight: 400;
          line-height: perS(8);
          color: #000;
          margin-top: perS(6);
        }
      }
    }
  }
  .result-wrap {
    margin: perS(22) 0 0 perS(25);
    position: relative;
    .tag {
      position: relative;
      margin-bottom: perS(0);
      .img {
        width: perS(70);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-7deg);
        position: absolute;
        top: perS(6.5);
        left: perS(10);
      }
    }
    .list {
      width: perS(169);
      .item {
        display: flex;
        .van-icon {
          margin-right: perS(8);
        }
        .text {
          font-size: perS(8);
          line-height: perS(16);
          font-weight: 500;
          color: #000;
          .green {
            color: #46b13a;
          }
        }
      }
    }
    .bottom-img1 {
      position: absolute;
      width: perS(117);
      height: auto;
      right: perS(45);
      top: perS(-5);
      z-index: 1;
    }
    .bottom-img2 {
      position: absolute;
      width: perS(127);
      height: auto;
      right: perS(25);
      top: perS(75);
      z-index: 2;
    }
    .bottom-line-red1 {
      position: absolute;
      width: perS(79);
      height: auto;
      right: perS(5);
      top: perS(40);
      z-index: 2;
    }
  }
}
@media screen and (max-height: 720px) {
  .page2-7 {
    .logo {
      top: 2vh;
    }
    .main-title {
      margin-top: 6vh;
    }
    .main-student {
      top: 7vh;
    }
  }
}
.common-video-button {
  display: inline-block;
  position: relative;
  padding: 10px;
  margin: perS(10) 0 0 perS(25);
  .border1 {
    border: 1px solid #ea5d40;
    border-radius: 16px;
    animation: 0.8s ease-in-out 0.6s videoBorderButtonFade infinite;
    position: absolute;
    top: 3px;
    left: 3px;
    width: 95px;
    height: 39px;
    display: none;
  }
  .border2 {
    border: 0.8px solid #ea5d40;
    border-radius: 15px;
    animation: 1s ease-in-out 0.3s videoBorderButtonFade infinite;
    position: absolute;
    top: 5px;
    left: 5px;
    width: 90px;
    height: 35px;
    display: none;
  }
  .border3 {
    border: 0.8px solid #ea5d40;
    border-radius: 14px;
    animation: 1s ease-in-out 0s videoBorderButtonFade infinite;
    position: absolute;
    top: 8px;
    left: 7px;
    width: 86px;
    height: 29px;
    display: none;
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ea5d40;
    border-radius: 15px;
    width: 82px;
    height: 26px;
    animation: 1.5s ease-in-out 0s videoBorderButtonScale infinite;
    .van-icon {
      font-size: 12px;
      margin-right: 4px;
      color: #fff;
    }
    .text {
      color: #fff;
      font-size: 12px;
      line-height: 12px;
      font-weight: 700;
    }
  }
}
@keyframes videoBorderButtonScale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.2);
  }
  70% {
    transform: scale(1);
  }
  80% {
    transform: scale(1);
  }
  90% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes videoBorderButtonFade {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.6;
  }
}
</style>
